var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import translate from "src/i18n/translate";
import "../lightcast/Lightcast.scss";
import { useEffect, useReducer } from "react";
import { sendRequest } from "src/common/http";
import { PopulationTrends, JobTrends, LaborForceTrends, UnemploymentTrends } from "../lightcast/Trends";
import BottomGrowingIndustries from "../lightcast/industries/BottomGrowingIndustries";
import TopGrowingIndustries from "../lightcast/industries/TopGrowingIndustries";
import BottomGrowingOccupations from "../lightcast/occupations/BottomGrowingOccupations";
import TopGrowingOccupations from "../lightcast/occupations/TopGrowingOccupations";
import PopulationByAge from "../lightcast/population/PopulationByAge";
import PopulationByRaceEthnicity from "../lightcast/population/PopulationByRaceEthnicity";
import { AnalyticView, AnalyticViewTable } from "../lightcast/LaborForce";
import ApiError from "../common/elements/ApiError";
var defaultIndustriesOrOccupations = {
    top: [],
    bottom: []
};
var defaultJobTrends = {
    JobsNationalRateGrowthIncrease: true,
    jobsFromTotalCount: 0,
    jobsGrowthIncrease: true,
    jobsNationalRatePercentage: 0,
    jobsPercentage: 0,
    jobsToTotalCount: 0
};
var defaultLaborForceBreakdown = {
    civilianPopulation: "",
    civilianPopulationPercentage: 0,
    employed: "",
    employedPercentage: 0,
    laborForcePopulation: "",
    laborForcePopulationPercentage: 0,
    notInLaborForce: "",
    notInLaborForcePercentage: 0,
    totalPopulation: "",
    under16: "",
    under16Percentage: 0,
    unemployed: "",
    unemployedPercentage: 0
};
var defaultLaborForceTrends = {
    laborForceGrowthIncrease: true,
    laborForceGrowthPercentageFrom: 0,
    laborForceGrowthPercentageTo: 0,
    laborForcePercentage: 0,
    unemploymentGrowthIncrease: true,
    unemploymentGrowthPercentageFrom: 0,
    unemploymentGrowthPercentageTo: 0,
    unemploymentPercentage: 0
};
var defaultPopulationTrends = {
    change: 0,
    changePercentage: 0,
    inclined: true,
    totalPopulation: 0
};
var defaultTimeframe = {
    currentYear: null,
    pastYear: null
};
var trendsDefaultAction = {
    type: "",
    laborForceTrendsInterface: {
        jobTrends: defaultJobTrends,
        laborForceBreakdown: defaultLaborForceBreakdown,
        laborForceTrends: defaultLaborForceTrends,
        populationTrends: defaultPopulationTrends,
        timeframe: defaultTimeframe
    },
    industries: defaultIndustriesOrOccupations,
    occupations: defaultIndustriesOrOccupations
};
var reducer = function (state, action) {
    var _a, _b, _c, _d;
    switch (action.type) {
        case "setLaborForceBreakdownAndTrends":
            return __assign(__assign({}, state), { populationTrends: action.laborForceTrendsInterface.populationTrends, jobTrends: action.laborForceTrendsInterface.jobTrends, laborForceTrends: action.laborForceTrendsInterface.laborForceTrends, timeframe: action.laborForceTrendsInterface.timeframe });
        case "setIndustries":
            return __assign(__assign({}, state), { bottomGrowingIndustries: (_a = action.industries) === null || _a === void 0 ? void 0 : _a.bottom, topGrowingIndustries: (_b = action.industries) === null || _b === void 0 ? void 0 : _b.top, loader: false });
        case "setOccupations":
            return __assign(__assign({}, state), { bottomGrowingOccupations: (_c = action.occupations) === null || _c === void 0 ? void 0 : _c.bottom, topGrowingOccupations: (_d = action.occupations) === null || _d === void 0 ? void 0 : _d.top, loader: false });
        case "setLaborForceBreakdownAndTrendsApiError":
            return __assign(__assign({}, state), { lfbApiError: true });
        case "setIndustriesApiError":
            return __assign(__assign({}, state), { industriesApiError: true, loader: false });
        case "setOccupationsApiError":
            return __assign(__assign({}, state), { occupationsApiError: true, loader: false });
        default:
            return state;
    }
};
var initialState = {
    populationTrends: null,
    jobTrends: null,
    laborForceTrends: null,
    timeframe: null,
    bottomGrowingIndustries: null,
    topGrowingIndustries: null,
    bottomGrowingOccupations: null,
    topGrowingOccupations: null,
    loader: true,
    lfbApiError: false,
    occupationsApiError: false,
    industriesApiError: false
};
var onTabLoad = function (tab) { };
function setTooglePosition(event, chartId) {
    var _a;
    var chartBodyRect;
    chartBodyRect = (_a = document
        .querySelector("." + chartId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var targetRect = event.target.getBoundingClientRect();
    var availableSpaceLeft = targetRect.left - (chartBodyRect === null || chartBodyRect === void 0 ? void 0 : chartBodyRect.left);
    var availableSpaceRight = (chartBodyRect === null || chartBodyRect === void 0 ? void 0 : chartBodyRect.right) - targetRect.right;
    if (window.innerWidth >= 1024) {
        event.target.childNodes[0].style.width = "180px";
    }
    else {
        event.target.childNodes[0].style.width = "160px";
    }
    if (availableSpaceLeft > availableSpaceRight) {
        event.target.childNodes[0].style.right = "30%";
        event.target.childNodes[0].style.removeProperty("left");
    }
    else {
        event.target.childNodes[0].style.left = "10%";
        event.target.childNodes[0].style.removeProperty("right");
    }
}
export default function TrendsExport(_a) {
    var setLaborForceBreakdown = _a.setLaborForceBreakdown, onComponentLoad = _a.onComponentLoad, laborForceBreakdown = _a.laborForceBreakdown;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, trendsDefaultAction), { type: "setLaborForceBreakdownAndTrends", laborForceTrendsInterface: result }));
            setLaborForceBreakdown(result.laborForceBreakdown);
            onComponentLoad("trends");
        };
        var onError = function () {
            dispatch(__assign(__assign({}, trendsDefaultAction), { type: "setLaborForceBreakdownAndTrendsApiError" }));
            onComponentLoad("trends");
        };
        sendRequest({ uri: "/lightcast/labor_force_breakdown_and_trends", camelize: true }, applyResult, onError);
    }, []);
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, trendsDefaultAction), { type: "setIndustries", industries: result }));
            onComponentLoad("industries");
        };
        var onError = function () {
            dispatch(__assign(__assign({}, trendsDefaultAction), { type: "setIndustriesApiError" }));
            onComponentLoad("industries");
        };
        sendRequest({ uri: "/lightcast/industries", camelize: true }, applyResult, onError);
    }, []);
    useEffect(function () {
        var applyResult = function (result) {
            dispatch(__assign(__assign({}, trendsDefaultAction), { type: "setOccupations", occupations: result }));
            onComponentLoad("occupations");
        };
        var onError = function () {
            dispatch(__assign(__assign({}, trendsDefaultAction), { type: "setOccupationsApiError" }));
            onComponentLoad("occupations");
        };
        sendRequest({ uri: "/lightcast/occupations", camelize: true }, applyResult, onError);
    }, []);
    return (_jsxs("div", { className: "", children: [_jsx("div", { className: "header", children: _jsxs("div", { className: "info", children: [_jsx("h3", { className: "title trends-title", children: translate("app.trends.trendsWidgetTitle") }), _jsx("p", { className: "description -des trends-desc", children: translate("app.trends.trendsWidgetDescription") })] }) }), !state.lfbApiError ? (_jsxs("div", { className: "body wm-grid-row trends-widget trends-body", children: [_jsx(PopulationTrends, { populationTrends: state.populationTrends, timeframe: state.timeframe }), _jsx(JobTrends, { jobTrends: state.jobTrends, timeframe: state.timeframe }), _jsx(LaborForceTrends, { laborForceTrends: state.laborForceTrends, timeframe: state.timeframe }), _jsx(UnemploymentTrends, { laborForceTrends: state.laborForceTrends, timeframe: state.timeframe })] })) : (_jsx(ApiError, {})), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx("div", { className: "grid-container change-in-population", children: _jsx(PopulationByAge, { setTooglePosition: setTooglePosition, onTabLoad: onTabLoad, onComponentLoad: onComponentLoad, showIntegratedHeader: false }) }), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx("div", { className: "grid-container change-in-population", children: _jsx(PopulationByRaceEthnicity, { setTooglePosition: setTooglePosition, onTabLoad: onTabLoad, onComponentLoad: onComponentLoad, showIntegratedHeader: false }) }), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx("div", { className: "header", children: _jsxs("div", { className: "info", id: "labor-force-info", children: [_jsx("h3", { className: "title html-title", children: translate("app.lightcast.laborForce.headingLabel") }), _jsx("div", { className: "description -labor-des html-desc", children: translate("app.lightcast.laborForce.helperLabel") })] }) }), !state.lfbApiError ? (_jsx(_Fragment, { children: laborForceBreakdown && (_jsxs("div", { className: "analytic-view-container", children: [_jsx(AnalyticView, { laborForceBreakdown: laborForceBreakdown }), _jsx(AnalyticViewTable, { laborForceBreakdown: laborForceBreakdown, forHtml: true })] })) })) : (_jsx("div", { id: "api-error", children: _jsx(ApiError, {}) })), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx(BottomGrowingIndustries, { industries: state.bottomGrowingIndustries, loader: state.loader, forHtml: true }), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx(TopGrowingIndustries, { industries: state.topGrowingIndustries, loader: state.loader, forHtml: true }), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx(BottomGrowingOccupations, { occupations: state.bottomGrowingOccupations, loader: state.loader, forHtml: true }), _jsx(LightcastSource, {}), _jsx("div", { className: "widget-border-margin" }), _jsx(TopGrowingOccupations, { occupations: state.topGrowingOccupations, loader: state.loader, forHtml: true }), _jsx(LightcastSource, {})] }));
}
var LightcastSource = function () {
    return (_jsx("div", { className: "source-margin", children: translate("app.lightcast.Source") }));
};
